exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-52ef0ea2]{padding:20px}table[data-v-52ef0ea2]{width:100%}form[data-v-52ef0ea2]{margin-bottom:10px}.info[data-v-52ef0ea2]{font-size:smaller;float:right}.empty-msg[data-v-52ef0ea2]{text-align:center}.incidents li[data-v-52ef0ea2]{display:block;padding:10px;border:1px solid #ccc;margin-bottom:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52ef0ea2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/List.vue
// module id = 147
// module chunks = 0